import Button from '@components/Button'
import DiscountInput from '@components/DiscountInput'
import InputCurrency from '@components/InputCurrency'
import Select from '@components/Select'
import TextField from '@components/TextField'
import Icon from '@material-ui/core/Icon'
import Switch from '@material-ui/core/Switch'
import { withStyles } from '@material-ui/core/styles'
import { apiClient } from '@services/api'
import { useEffect, useState } from 'react'

const GreenRedSwitch = withStyles({
  switchBase: {
    color: '#ef4444',
    '&$checked': { color: '#22c55e' },
    '&$checked + $track': { backgroundColor: '#22c55e', opacity: 0.5 },
  },
  track: { backgroundColor: '#ef4444', opacity: 0.5 },
  checked: {},
})(Switch)

const Form = (props) => {
  const tourPeriodOptions = [
    {
      value: "halfday",
      label: "Meio período"
    },
    {
      value: "fullday",
      label: "Integral"
    }
  ]
  const dayPeriodOptions = [
    {
      value: "AM",
      label: "Antes do meio-dia"
    },
    {
      value: "PM",
      label: "Depois do meio-dia"
    }
  ]
  const [regionOptions, setRegionOptions] = useState([])
  const getRegions = () => {
    apiClient
      .httpInstance.get('/regions').then(response => {
        if (response.status === 200) {
          setRegionOptions(response.data);
        }
      });
  }
  useEffect(() => {
    getRegions()
  }, [])

  return <>
    <form onSubmit={props.submit}>
      <div className="p-4 mt-4 bg-white rounded-xl border-1">
        <div className="flex flex-col md:flex-row mb-4 gap-3">
          <div className="flex-1">
            <TextField
              className="inputRounded"
              label="Nome do passeio"
              variant="outlined"
              type="text"
              name="name"
              value={props.tour.name}
              onChange={(ev) => props.changeState(ev)}
              required
            />
          </div>
          <div className="flex-1">
            <Select
              withoutAll
              label="região do passeio"
              value={props.tour.region}
              onChange={(ev) => props.changeState(ev)}
              name="region"
              defaultValue={props.isEditing ? " " : ''}
              items={{
                field: {
                  value: 'id',
                  text: 'name'
                },
                data: regionOptions
              }}
              required
            />
          </div>
          <div className="flex-1">
            <Select
              withoutAll
              label="Período do passeio"
              defaultValue={props.isEditing ? " " : ''}
              value={props.tour.tour_period}
              onChange={(ev) => props.changeState(ev)}
              name="tour_period"
              items={{
                field: {
                  value: 'value',
                  text: 'label'
                },
                data: tourPeriodOptions
              }}
            />
          </div>
          <div className="flex-1">
            <Select
              disabled={props.tour.tour_period === 'fullday' ? true : false}
              withoutAll
              label="Período do dia"
              value={props.tour.tour_period === 'fullday' ? null : props.tour.day_period}
              onChange={(ev) => props.changeState(ev)}
              name="day_period"
              defaultValue={props.isEditing ? " " : ''}
              items={{
                field: {
                  value: 'value',
                  text: 'label'
                },
                data: dayPeriodOptions
              }}
            />
          </div>
        </div>
        <div className="flex mb-4 space-x-1">
          <TextField
            className="inputRounded"
            placeholder="Descrição"
            variant="outlined"
            multiline
            rows={2}
            name="description"
            value={props.tour.description}
            onChange={(ev) => props.changeState(ev)}
          />
        </div>
        <div className="flex mb-4 space-x-1">
          <TextField
            className="inputRounded"
            placeholder="O que inclui (ex: guia em português, seguro, ingresso...)"
            variant="outlined"
            multiline
            rows={2}
            name="whats_included"
            value={props.tour.whats_included ?? ''}
            onChange={(ev) => props.changeState(ev)}
          />
        </div>
        <div className="flex mb-4 space-x-1 pb-8">
          <TextField
            className="inputRounded"
            placeholder="O que não inclui (ex: alimentação, traslado, gorjetas...)"
            variant="outlined"
            multiline
            rows={2}
            name="whats_not_included"
            value={props.tour.whats_not_included ?? ''}
            onChange={(ev) => props.changeState(ev)}
          />
        </div>
        <span className="text-2xl text-blue ">Passeio em grupo</span>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-8">
          <div>
            <p className="text-gray">Adulto</p>
            <div className="grid grid-cols-2 gap-3 mt-7 mb-4">
              <InputCurrency
                className="inputRounded"
                label="Valor"
                variant="outlined"
                name="price"
                value={props.tour.price}
                onChange={(ev) => props.changeState(ev)}
              />
              <DiscountInput
                typeService="tour"
                label="Desconto"
                name="adult_discount_percentage"
                value={props.tour.adult_discount_percentage}
                onChange={(ev) => props.changeState(ev)}
                width="70px"
              />
              <InputCurrency
                className="inputRounded"
                label="C. op. Parceiro"
                variant="outlined"
                name="operational_cost"
                value={props.tour.operational_cost}
                onChange={(ev) => props.changeState(ev)}
              />
              <InputCurrency
                className="inputRounded"
                label="C. op. Venda"
                variant="outlined"
                name="operational_cost_sale"
                value={props.tour.operational_cost_sale}
                onChange={(ev) => props.changeState(ev)}
              />
            </div>
          </div>
          <div>
            <div className="flex items-center justify-between mb-2">
              <p className="text-gray">Criança</p>
              <label className="flex items-center gap-1 cursor-pointer select-none">
                <GreenRedSwitch
                  checked={!!props.tour.kids_allowed}
                  onChange={(ev) => props.changeState({ target: { name: 'kids_allowed', value: ev.target.checked } })}
                  size="small"
                />
                <span className="text-sm text-gray">Permitir crianças</span>
              </label>
            </div>
            <div className="grid grid-cols-2 gap-3 mt-7 mb-4">
              <InputCurrency
                className="inputRounded"
                label="Valor"
                variant="outlined"
                name="kids_price"
                value={props.tour.kids_price}
                onChange={(ev) => props.changeState(ev)}
              />
              <DiscountInput
                typeService=""
                showNewPercent={true}
                label="Desconto"
                name="kid_discount_percentage"
                value={props.tour.kid_discount_percentage}
                onChange={(ev) => props.changeState(ev)}
                width="70px"
              />
              <InputCurrency
                className="inputRounded"
                label="C. op. Parceiro"
                variant="outlined"
                name="kid_operational_cost"
                value={props.tour.kid_operational_cost}
                onChange={(ev) => props.changeState(ev)}
              />
              <InputCurrency
                className="inputRounded"
                label="C. op. Venda"
                variant="outlined"
                name="kid_operational_cost_sale"
                value={props.tour.kid_operational_cost_sale}
                onChange={(ev) => props.changeState(ev)}
              />
            </div>
          </div>
        </div>
        <p className="text-2xl text-blue mb-4">Passeio privado</p>
        {props.tour.private_values.map((obj, idx) => {
          return <div className="pb-4" key={idx}>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-4">
              <InputCurrency
                className="inputRounded"
                label="Valor"
                variant="outlined"
                name="value"
                value={obj.value}
                onChange={(ev) => props.changeStatePrivate(idx, ev)}
                required={Number(obj.value) > 0 ? true : false}
              />
              <InputCurrency
                className="inputRounded"
                label="C. op. Parceiro"
                variant="outlined"
                name="cost"
                value={obj.cost}
                onChange={(ev) => props.changeStatePrivate(idx, ev)}
                required={Number(obj.value) > 0 ? true : false}
              />
              <InputCurrency
                className="inputRounded"
                label="C. op. Venda"
                variant="outlined"
                name="cost_sale"
                value={obj.cost_sale}
                onChange={(ev) => props.changeStatePrivate(idx, ev)}
                required={Number(obj.value) > 0 ? true : false}
              />
              <TextField
                disabled
                className="inputRounded"
                label="Mín. de pessoas"
                variant="outlined"
                type="text"
                name="min_people"
                value={obj.min_people}
                onChange={(ev) => props.changeStatePrivate(idx, ev)}
                required={Number(obj.value) > 0 ? true : false}
              />
              <TextField
                disabled={props.tour.private_values.length - 1 > idx}
                className="inputRounded"
                label="Máx. de pessoas"
                variant="outlined"
                type="number"
                name="max_people"
                value={obj.max_people}
                min={obj.min_people}
                onChange={(ev) => props.changeStatePrivate(idx, ev)}
                required={Number(obj.value) > 0 ? true : false}
              />
              <div className="flex items-center gap-3">
                <DiscountInput
                  typeService=""
                  label="Desconto"
                  name="discount"
                  showNewPercent={true}
                  value={obj.discount}
                  onChange={(ev) => props.changeStatePrivate(idx, ev)}
                  width="70px"
                />
                {idx > 0 &&
                  <Icon className="cursor-pointer text-red-500" onClick={() => props.removePrivate(idx)}>delete</Icon>
                }
              </div>
            </div>
          </div>
        })}
        <div className="flex ">
          <div className="flex-1 mb-3">
            <span className="text-gray cursor-pointer" onClick={() => props.addPrivate()}>+ Adicionar intervalo</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 pb-4 items-center">
          <div className="flex-1 mb-3 mr-3">
            <p className="text-2xl text-blue mb-4 mt-5">Venda no site</p>
            <TextField
              className="inputRounded"
              label="quantidade mínima"
              variant="outlined"
              type="number"
              name="min_quantity"
              value={props.tour.min_quantity}
              onChange={(ev) => props.changeState(ev)}
            />
          </div>


          <div className="flex-1 mb-3 ml-3">
            <p className="text-2xl text-blue mb-4 mt-5">ID do passeio no site</p>
            <TextField
              className="inputRounded"
              label="ID"
              variant="outlined"
              type="number"
              name="id_site"
              value={props.tour.id_site}
              onChange={(ev) => props.changeState(ev)}
            />
          </div>

        </div>

      </div>
      <div className="text-right pb-4">
        <Button
          textcolor="#FFF"
          padding="6px 15px"
          width="200"
          customcolor={props.theme.color}
          type="submit"
        >
          Salvar
        </Button>
      </div>
    </form>
  </>
}

export default Form
